import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  BAR_REPORT_DATE_SEARCH_REQUEST,
  BAR_REPORT_DATE_SEARCH_SUCCESS,
  BAR_REPORT_DATE_SEARCH_FAILURE,
  BAR_REPORT_DATE_WEEK_SEARCH_SUCCESS,
  BAR_REPORT_DATE_MONTH_SEARCH_REQUEST,
  BAR_REPORT_DATE_MONTH_SEARCH_SUCCESS,
  BAR_REPORT_DATE_MONTH_SEARCH_FAILURE,
  BAR_REPORT_DATE_WEEK_SEARCH_REQUEST,
  BAR_REPORT_DATE_WEEK_SEARCH_FAILURE,
  REPORT_BAR_REPORT_REQUEST,
  REPORT_BAR_REPORT_SUCCESS,
  REPORT_BAR_REPORT_FAILURE,
  REPORT_BAR_MONTH_REPORT_REQUEST,
  REPORT_BAR_MONTH_REPORT_SUCCESS,
  REPORT_BAR_MONTH_REPORT_FAILURE,
  REPORT_BAR_WEEK_SEARCH_REQUEST,
  REPORT_BAR_WEEK_SEARCH_FAILURE,
  REPORT_BAR_REPORT_SEARCH_REQUEST,
  REPORT_BAR_REPORT_SEARCH_SUCCESS,
  REPORT_BAR_REPORT_SEARCH_FAILURE,
  REPORT_BAR_WEEK_SEARCH_SUCCESS,
} from "./BarReportTypes";

const initialState = {
  viewAllBarReports: { ...defaultStatus },
  monthBarReports: { ...defaultStatus },
  weekBarReports: { ...defaultStatus },
  dateMonthSearchBarReports: { ...defaultStatus },
  dateWeekSearchBarReports: { ...defaultStatus },
  dateSearchBarReports: { ...defaultStatus },
  searchBarReports: { ...defaultStatus },
};

export default function reportReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    //Bar Month Report Search
    case REPORT_BAR_MONTH_REPORT_REQUEST:
      return {
        ...state,
        monthBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_BAR_MONTH_REPORT_SUCCESS:
      return {
        ...state,
        monthBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_BAR_MONTH_REPORT_FAILURE:
      return {
        ...state,
        monthBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Bar Week Report Search
    case REPORT_BAR_WEEK_SEARCH_REQUEST:
      return {
        ...state,
        weekBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_BAR_WEEK_SEARCH_SUCCESS:
      return {
        ...state,
        weekBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_BAR_WEEK_SEARCH_FAILURE:
      return {
        ...state,
        weekBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Bar Day Report Search
    case REPORT_BAR_REPORT_REQUEST:
      return {
        ...state,
        viewAllBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_BAR_REPORT_SUCCESS:
      return {
        ...state,
        viewAllBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_BAR_REPORT_FAILURE:
      return {
        ...state,
        viewAllBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Bar Month Date Search
    case BAR_REPORT_DATE_MONTH_SEARCH_REQUEST:
      return {
        ...state,
        dateMonthSearchBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BAR_REPORT_DATE_MONTH_SEARCH_SUCCESS:
      return {
        ...state,
        dateMonthSearchBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case BAR_REPORT_DATE_MONTH_SEARCH_FAILURE:
      return {
        ...state,
        dateMonthSearchBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Bar Week Date Search
    case BAR_REPORT_DATE_WEEK_SEARCH_REQUEST:
      return {
        ...state,
        dateWeekSearchBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BAR_REPORT_DATE_WEEK_SEARCH_SUCCESS:
      return {
        ...state,
        dateWeekSearchBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case BAR_REPORT_DATE_WEEK_SEARCH_FAILURE:
      return {
        ...state,
        dateWeekSearchBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Bar Day Date Search
    case BAR_REPORT_DATE_SEARCH_REQUEST:
      return {
        ...state,
        dateSearchBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case BAR_REPORT_DATE_SEARCH_SUCCESS:
      return {
        ...state,
        dateSearchBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case BAR_REPORT_DATE_SEARCH_FAILURE:
      return {
        ...state,
        dateSearchBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Bar Report Search
    case REPORT_BAR_REPORT_SEARCH_REQUEST:
      return {
        ...state,
        searchBarReports: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case REPORT_BAR_REPORT_SEARCH_SUCCESS:
      return {
        ...state,
        searchBarReports: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case REPORT_BAR_REPORT_SEARCH_FAILURE:
      return {
        ...state,
        searchBarReports: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    default:
      return state;
  }
}
